export const TRICLINIC = {
  text: "chemical.TRICLINIC",
  value: 1
};
export const MONOCLINIC = {
  text: "chemical.MONOCLINIC",
  value: 2
};
export const ORTHORHOMBIC = {
  text: "chemical.ORTHORHOMBIC",
  value: 3
};
export const TETRAGONAL = {
  text: "chemical.TETRAGONAL",
  value: 4
};
export const TRIGONAL = {
  text: "chemical.TRIGONAL",
  value: 5
};
export const HEXAGONAL = {
  text: "chemical.HEXAGONAL",
  value: 6
};
export const CUBIC = {
  text: "chemical.CUBIC",
  value: 7
};
